var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{style:(`width: ${_vm.width}px; height: ${_vm.height}px; font-size: ${_vm.fontSize}px;`),attrs:{"option":_vm.options,"init-options":{renderer: 'svg'},"autoresize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }